import React, { useState } from "react";

const SendSmsBulkPopup = ({ onClose, dropdownOptions, onSubmit }) => {
  const decodeHTMLEntities = (text) => {
    const textArea = document.createElement("textarea");
    textArea.innerHTML = text;
    return textArea.value;
  };

  const [sendSmsData, setSendSmsData] = useState({
    pushTemplate: "",
    message: "",
  });

  const handleSendSmsInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "pushTemplate") {
      const selectedTemplate = dropdownOptions.templateSmsList.find(
        (template) => template.id === parseInt(value)
      );

      setSendSmsData((prevData) => ({
        ...prevData,
        pushTemplate: value,
        message: selectedTemplate
          ? decodeHTMLEntities(selectedTemplate.message)
          : "",
      }));
    } else {
      setSendSmsData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(sendSmsData);
    onClose();
    setSendSmsData({
      pushTemplate: "",
      message: "",
    });
  };
  return (
    <div
      className="modal fade show"
      style={{ display: "block" }}
      tabIndex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <div className="col-md-6">
              <h5 className="modal-title" style={{ fontWeight: "bold" }}>
                Send SMS
              </h5>
            </div>
            <div className="col-md-6">
              <button
                type="button"
                className="btn btn-default float-end"
                onClick={onClose}
              >
                &times;
              </button>
            </div>
            <div className="clearfix"></div>
          </div>
          <div className="modal-body">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label className="control-label">Select SMS Template</label>
                    <select
                      name="pushTemplate"
                      className="form-control"
                      onChange={handleSendSmsInputChange}
                      value={sendSmsData.pushTemplate}
                    >
                      <option value="">- Select -</option>
                      {dropdownOptions.templateSmsList.map((option, index) => (
                        <option key={index} value={option.id}>
                          {option.template_name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="col-md-12">
                  <fieldset className="form-group">
                    <label className="form-label semibold">Message</label>
                    <textarea
                      name="message"
                      placeholder="Enter Message"
                      className="form-control"
                      value={sendSmsData.message}
                      onChange={handleSendSmsInputChange}
                    />
                  </fieldset>
                </div>

                <div className="col-md-3">
                  <div style={{ float: "left", marginTop: "20px" }}>
                    <button
                      type="submit"
                      name="submit"
                      className="btn btn-primary mx-2"
                    >
                      Submit
                    </button>
                  </div>
                  <div
                    style={{
                      float: "left",
                      marginTop: "20px",
                      marginLeft: "10px",
                    }}
                  >
                    <button
                      type="button"
                      name="cancel"
                      className="btn btn-default"
                      onClick={onClose} // Close the modal on cancel
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SendSmsBulkPopup;
